import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import '../styles/Footer.css';
import logo from '../assets/logo_long.png'; // Import the logo

const Footer = () => {
  const { translations } = useContext(LanguageContext);
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={logo} alt="Logo" className="footer-logo-image" />
          <div className="footer-policy-terms">
            <a href="/terms-of-service">{translations.footer.termsOfService}</a>
            <a href="/privacy-policy">{translations.footer.privacyPolicy}</a>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-links-column-1">
            <h3>{translations.footer.viewMyWork}</h3>
            <a href="https://youtube.com/@rokyuto404?si=3-EgHq3mOoBRcM_w" target="_blank" rel="noopener noreferrer"><img src={'https://rokyuto-media-bucket.s3.eu-north-1.amazonaws.com/icons/youtube.png'} className='linkImages' alt='' />YouTube</a>
            <a href="https://huggingface.co/Rokyuto" target="_blank" rel="noopener noreferrer"><img src={'https://rokyuto-media-bucket.s3.eu-north-1.amazonaws.com/icons/hug.png'} className='linkImages' alt='' />HuggingFace</a>
            <a href="https://github.com/Rokyuto" target="_blank" rel="noopener noreferrer"><img src={'https://rokyuto-media-bucket.s3.eu-north-1.amazonaws.com/icons/github.png'} className='linkImages' alt='' />GitHub</a>
          </div>
          <div className="footer-links-column-2">
            <h3>{translations.footer.contact}</h3>
            <a href="https://www.linkedin.com/in/viktor-asenov-9511404v5/" target="_blank" rel="noopener noreferrer"><img src={'https://rokyuto-media-bucket.s3.eu-north-1.amazonaws.com/icons/linkedin.png'} className='linkImages' alt='' /> LinkedIn</a>
            <a href="https://www.instagram.com/_viktor.asenov_/" target="_blank" rel="noopener noreferrer"><img src={'https://rokyuto-media-bucket.s3.eu-north-1.amazonaws.com/icons/instagram.png'} className='linkImages' alt='' /> Instagram</a>
            <a href="https://www.facebook.com/share/To3zU6Fez1Lt1asF/" target="_blank" rel="noopener noreferrer"><img src={'https://rokyuto-media-bucket.s3.eu-north-1.amazonaws.com/icons/facebook.png'} className='linkImages' alt='' /> Facebook</a>
          </div>
        </div>
      </div>
      <p id='copyright' >{translations.footer.copyright}</p>
    </footer>
  );
};

export default Footer;
